import AppConstants from "../constants/AppConstants";
import config from "../config/app";
import _ from "lodash";

const PUBLISH_ID_LENGTH = 21;

var DesignUtils = {
  getPublishedDesignPreviewImageURL(pubKey, layout) {
    return (
      config.assetURL +
      "/site/" +
      pubKey +
      "/" +
      "preview/" +
      (layout == AppConstants.LAYOUT_DESKTOP ? "d" : "m") +
      "/index.jpg"
    );
  },

  /**
   * @param site is an Immutable Object
   */
  getLibraryPreviewURL: function (site) {
    var key = site.get("key", false);
    return this.getPreviewURL(key);
  },

  getPreviewURL: function (designKey) {
    var url = false;

    if (designKey) {
      if (designKey.indexOf("/") > 0) {
        url = "//" + this.encodeKeyForSubdomain(designKey) + ".design." + config.previewDomain;
      } else {
        url = "//" + this.encodeKeyForSubdomain(designKey) + "." + config.previewDomain;
      }
    }

    return url;
  },

  /**
   * Key from published cannot be converted.
   */
  encodeKeyForSubdomain: function (key) {
    let sub = key.replace("/", "");
    sub = sub.replace(/-/g, "-d");
    sub = sub.replace(/_/g, "-u");

    return sub;
  },

  decodeSubdomainToKey: function (subdomain) {
    let key = subdomain.replace(/-u/g, "_");
    key = key.replace(/-d/g, "-");

    key = key.substring(0, key.length - PUBLISH_ID_LENGTH) + "/" + key.substr(-PUBLISH_ID_LENGTH);

    return key;
  },
};

export default DesignUtils;
